import { collection, getDocs, getFirestore } from "firebase/firestore";

// Utils
import { sentryErrorLog } from "utils/sentryLog";

export const getVaultsData = async () => {
  try {
    const db = getFirestore();

    const snapshot = await getDocs(collection(db, "vaults"));

    const data: any = {};

    snapshot.forEach((doc) => {
      if (doc) {
        const docData = doc.data();
        data[doc.id] = docData;
      }
    });

    return data as any;
  } catch (error) {
    sentryErrorLog(error);
    return {
      error,
    };
  }
};
